// Mock data for Cooper Equipment Rentals

export const equipmentCategories = [
  // ============ FEATURED SCISSOR LIFTS ============
  {
    id: 1,
    name: "19' Electric Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Electric Scissor Lift",
    description: "A compact electric slab scissor lift with a narrow platform, designed for vertical access on smooth indoor surfaces.",
    seoDescription: "Rent a 19 ft electric scissor lift for compact indoor aerial work on smooth concrete. This narrow electric scissor lift is ideal for ceiling work, lighting, HVAC, warehouse maintenance, painting, and tight jobsites where a ladder is not safe or efficient.",
    image: "/equipment/eq_01.jpg",
    popular: true,
    featured: true,
    pricing: {
      daily: 288.8, weekly: 524.0, monthly: 787.2,
      competitor: { daily: 410.08, weekly: 580.87, monthly: 915.72 },
    },
    features: [
      "Compact size for tight indoor spaces and finished buildings",
      "Fits through standard doorways",
      "Best for vertical access on smooth concrete or slab surfaces",
    ],
    brands: [
      {
        name: "Skyjack", model: "SJ3219", image: "/equipment/eq_01.jpg",
        pricing: { daily: 288.8, weekly: 524.0, monthly: 787.2 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '24\' 6"',
          "Platform Height": '18\' 6"',
          "Machine Length": '71"',
          "Machine Width": '32"',
          "Stowed Height": '79.6"',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '3,236 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "GS-1930", image: "/equipment/eq_02.jpg",
        pricing: { daily: 288.8, weekly: 524.0, monthly: 787.2 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '25 ft 3 in',
          "Platform Height": '19 ft 3 in',
          "Machine Length": '6 ft',
          "Machine Width": '2 ft 6 in',
          "Stowed Height": '5 ft 11 in',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '3,209 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 2,
    name: "26' Narrow Electric Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Electric Scissor Lift",
    description: "Rent a 26 ft narrow electric scissor lift when you need extra indoor reach without giving up maneuverability. This lift is a strong fit for electrical, drywall, fire sprinkler, HVAC, warehouse, and facility work in narrow access areas.",
    seoDescription: "Rent a 26 ft narrow electric scissor lift when you need extra indoor reach without giving up maneuverability. This lift is a strong fit for electrical, drywall, fire sprinkler, HVAC, warehouse, and facility work in narrow access areas.",
    image: "/equipment/eq_03.jpg",
    popular: true,
    featured: false,
    pricing: {
      daily: 328.0, weekly: 608.0, monthly: 921.6,
      competitor: { daily: 457.72, weekly: 693.31, monthly: 1164.41 },
    },
    features: ["26' working height", "Narrow design", "Indoor capable"],
    brands: [
      {
        name: "Skyjack", model: "SJ3226", image: "/equipment/eq_03.jpg",
        pricing: { daily: 328.0, weekly: 608.0, monthly: 921.6 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '32\' 6"',
          "Platform Height": '26\' 6"',
          "Machine Length": '91.5"',
          "Machine Width": '32"',
          "Stowed Height": '84.5"',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '4,130 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "GS-2632", image: "/equipment/eq_04.jpg",
        pricing: { daily: 328.0, weekly: 608.0, monthly: 921.6 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '32 ft',
          "Platform Height": '26 ft',
          "Machine Length": '7 ft 5 in',
          "Machine Width": '2 ft 8 in',
          "Stowed Height": '7 ft 2 in',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '4,413 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 3,
    name: "26' Wide Electric Scissor Lift",
    displayName: "26' Electric Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Electric Scissor Lift",
    description: "An electric slab scissor lift with a higher platform height for vertical access on smooth, level surfaces.",
    seoDescription: "Rent a 26 ft wide electric scissor lift for indoor slab work that needs more deck space and platform capacity. This lift works well for painting, framing, overhead mechanical, electrical, and general commercial construction on flat concrete.",
    image: "/equipment/eq_05.jpg",
    popular: true,
    featured: true,
    featuredOrder: 2,
    pricing: {
      daily: 328.0, weekly: 608.0, monthly: 921.6,
      competitor: { daily: 465.00, weekly: 705.00, monthly: 1180.00 },
    },
    features: [
      "Provides added height for indoor overhead work",
      "Stable platform for installation, maintenance, and trade work",
      "Ideal for indoor construction, warehouses, and commercial buildings",
    ],
    brands: [
      {
        name: "Skyjack", model: "SJ4726", image: "/equipment/eq_05.jpg",
        pricing: { daily: 328.0, weekly: 608.0, monthly: 921.6 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '31\' 8"',
          "Platform Height": '25\' 8"',
          "Machine Length": '91.6"',
          "Machine Width": '47"',
          "Stowed Height": '90"',
          "Platform Capacity": '1,000 lbs',
          "Operating Weight": '4,740 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "GS-2646", image: "/equipment/eq_06.jpg",
        pricing: { daily: 328.0, weekly: 608.0, monthly: 921.6 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '32 ft',
          "Platform Height": '26 ft',
          "Machine Length": '8 ft',
          "Machine Width": '3 ft 10 in',
          "Stowed Height": '7 ft 5 in',
          "Platform Capacity": '1,000 lbs',
          "Operating Weight": '4,312 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 4,
    name: "26' Rough Terrain Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Rough Terrain Scissor Lift",
    description: "Rent a 26 ft rough terrain scissor lift for outdoor jobsites where crews need a stable platform on dirt, gravel, asphalt, or uneven ground. This lift is useful for framing, siding, painting, exterior maintenance, and general construction.",
    seoDescription: "Rent a 26 ft rough terrain scissor lift for outdoor jobsites where crews need a stable platform on dirt, gravel, asphalt, or uneven ground. This lift is useful for framing, siding, painting, exterior maintenance, and general construction.",
    image: "/equipment/eq_09.jpg",
    popular: true,
    featured: false,
    pricing: {
      daily: 414.0, weekly: 806.0, monthly: 1422.0,
      competitor: { daily: 545.00, weekly: 1050.00, monthly: 1850.00 },
    },
    features: ["26' working height", "Rough terrain capable", "Diesel power"],
    brands: [
      {
        name: "Skyjack", model: "SJ6826 RT", image: "/equipment/eq_09.jpg",
        pricing: { daily: 414.0, weekly: 806.0, monthly: 1422.0 },
        specs: {
          "Equipment Type": 'Rough terrain scissor',
          "Work Height": '32 ft',
          "Platform Height": '26 ft',
          "Machine Length": '107.5"',
          "Machine Width": '69"',
          "Stowed Height": '90.5"',
          "Platform Capacity": '1,250 lbs',
          "Operating Weight": '7,300 lbs',
          "Power": 'Gas / LPG or diesel, configuration varies',
        },
      },
    ],
  },
  {
    id: 5,
    name: "18'-20' Reach 5,000lbs Telehandler",
    category: "Telehandler",
    description: "Rent a compact 5,500 lb telehandler when you need forklift-style material handling with added reach. This machine is useful for moving pallets, lifting materials to decks, placing loads on jobsites, and working in tighter construction areas.",
    seoDescription: "Rent a compact 5,500 lb telehandler when you need forklift-style material handling with added reach. This machine is useful for moving pallets, lifting materials to decks, placing loads on jobsites, and working in tighter construction areas.",
    image: "/equipment/eq_42.jpg",
    popular: true,
    featured: false,
    pricing: {
      daily: 1090.0, weekly: 2440.0, monthly: 5590.0,
      competitor: { daily: 560.00, weekly: 1100.00, monthly: 1950.00 },
    },
    features: ["18'-20' reach", "5,000 lbs capacity", "Versatile attachment options"],
    brands: [
      {
        name: "Genie", model: "GTH-5519", image: "/equipment/eq_42.jpg",
        pricing: { daily: 1090.0, weekly: 2440.0, monthly: 5590.0 },
        specs: {
          "Equipment Type": 'Compact telehandler',
          "Lift Capacity": '5,500 lbs',
          "Max Lift Height": '18 ft 10 in',
          "Max Forward Reach": '11 ft 3 in',
          "Capacity at Max Height": '4,400 lbs',
          "Capacity at Max Reach": '1,900 lbs',
          "Machine Length": '12 ft 3 in (without forks)',
          "Machine Width": '5 ft 11 in',
          "Stowed Height": '6 ft 6 in',
          "Operating Weight": '10,360 lbs',
          "Power": 'Diesel',
        },
      },
    ],
  },
  {
    id: 6,
    name: "12' Vertical Mast Lift",
    category: "Scissor Lift",
    equipmentType: "Vertical Mast Lift",
    description: "Rent a 12 ft vertical mast lift for compact indoor access where space is tight and a ladder is not the best option. This lift is useful for office buildings, retail spaces, schools, warehouses, and facility maintenance.",
    seoDescription: "Rent a 12 ft vertical mast lift for compact indoor access where space is tight and a ladder is not the best option. This lift is useful for office buildings, retail spaces, schools, warehouses, and facility maintenance.",
    image: "/equipment/eq_12.jpg",
    popular: true,
    featured: false,
    pricing: {
      daily: 272.0, weekly: 412.0, monthly: 580.0,
      competitor: { daily: 340.00, weekly: 510.00, monthly: 750.00 },
    },
    features: ["12' working height", "Ultra-compact", "Indoor use"],
    brands: [
      {
        name: "Skyjack", model: "SJ12 E", image: "/equipment/eq_12.jpg",
        pricing: { daily: 272.0, weekly: 412.0, monthly: 580.0 },
        specs: {
          "Equipment Type": 'Vertical mast lift',
          "Work Height": '18 ft',
          "Platform Height": '12 ft',
          "Machine Length": '54"',
          "Machine Width": '30.5"',
          "Stowed Height": '74"',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '1,986 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "GR-12", image: "/equipment/eq_13.jpg",
        pricing: { daily: 272.0, weekly: 412.0, monthly: 580.0 },
        specs: {
          "Equipment Type": 'Vertical mast lift',
          "Work Height": '17 ft 4 in',
          "Platform Height": '11 ft 4 in',
          "Machine Length": '4 ft 5 in',
          "Machine Width": '2 ft 5.5 in',
          "Stowed Height": '5 ft 10 in',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '1,681 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },

  // ============ SCISSOR LIFT - Additional ============
  {
    id: 7,
    name: "32' Wide Electric Scissor Lift",
    displayName: "32' Electric Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Electric Scissor Lift",
    description: "A wide electric slab scissor lift with added platform height and workspace for elevated indoor access.",
    seoDescription: "Rent a 32 ft wide electric scissor lift for warehouse, tilt-up, and commercial interior projects where crews need higher vertical access and a stable work platform. This size is popular for ceiling work, electrical, painting, drywall, and overhead installation.",
    image: "/equipment/eq_07.jpg",
    featured: true,
    featuredOrder: 3,
    pricing: {
      daily: 372.8, weekly: 664.0, monthly: 1168.0,
      competitor: { daily: 515.00, weekly: 920.00, monthly: 1420.00 },
    },
    features: [
      "Higher reach for larger indoor and slab projects",
      "Wider platform gives more room for workers, tools, and materials",
      "Good choice for ceiling work, lighting, HVAC, drywall, and painting",
    ],
    brands: [
      {
        name: "Skyjack", model: "SJ4732", image: "/equipment/eq_07.jpg",
        pricing: { daily: 372.8, weekly: 664.0, monthly: 1168.0 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '37\' 8"',
          "Platform Height": '31\' 8"',
          "Machine Length": '91.6"',
          "Machine Width": '47"',
          "Stowed Height": '94"',
          "Platform Capacity": '700 lbs',
          "Operating Weight": '5,496 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 8,
    name: "40' Wide Electric Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Electric Scissor Lift",
    description: "Rent a 40 ft electric scissor lift for tall indoor spaces and commercial jobsites that need high vertical access on flat concrete. This lift is commonly used in warehouses, gymnasiums, industrial buildings, and tilt-up projects for lighting, mechanical, painting, and ceiling work.",
    seoDescription: "Rent a 40 ft electric scissor lift for tall indoor spaces and commercial jobsites that need high vertical access on flat concrete. This lift is commonly used in warehouses, gymnasiums, industrial buildings, and tilt-up projects for lighting, mechanical, painting, and ceiling work.",
    image: "/equipment/eq_08.jpg",
    pricing: {
      daily: 473.6, weekly: 776.0, monthly: 1504.0,
      competitor: { daily: 625.00, weekly: 1140.00, monthly: 1750.00 },
    },
    features: ["40' working height", "Wide platform", "Indoor/outdoor"],
    brands: [
      {
        name: "Skyjack", model: "SJ4740", image: "/equipment/eq_08.jpg",
        pricing: { daily: 473.6, weekly: 776.0, monthly: 1504.0 },
        specs: {
          "Equipment Type": 'Electric slab scissor',
          "Work Height": '45\' 5"',
          "Platform Height": '39\' 5"',
          "Machine Length": '94.5"',
          "Machine Width": '47"',
          "Stowed Height": '98.2"',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '6,830 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 9,
    name: "32' Rough Terrain Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Rough Terrain Scissor Lift",
    description: "Rent a 32 ft rough terrain scissor lift for outdoor construction work that needs more height and a larger work platform. This lift is well suited for exterior painting, framing, glazing, siding, steel, and commercial building maintenance.",
    seoDescription: "Rent a 32 ft rough terrain scissor lift for outdoor construction work that needs more height and a larger work platform. This lift is well suited for exterior painting, framing, glazing, siding, steel, and commercial building maintenance.",
    image: "/equipment/eq_10.jpg",
    pricing: {
      daily: 470.0, weekly: 918.0, monthly: 1646.0,
      competitor: { daily: 610.00, weekly: 1175.00, monthly: 2070.00 },
    },
    features: ["32' working height", "All-terrain", "Diesel powered"],
    brands: [
      {
        name: "Skyjack", model: "SJ6832 RT", image: "/equipment/eq_10.jpg",
        pricing: { daily: 470.0, weekly: 918.0, monthly: 1646.0 },
        specs: {
          "Equipment Type": 'Rough terrain scissor',
          "Work Height": '38 ft',
          "Platform Height": '32 ft',
          "Machine Length": '107.5"',
          "Machine Width": '69"',
          "Stowed Height": '96.5"',
          "Platform Capacity": '1,000 lbs',
          "Operating Weight": '7,700 lbs',
          "Power": 'Gas / LPG or diesel, configuration varies',
        },
      },
    ],
  },
  {
    id: 10,
    name: "43' Rough Terrain Scissor Lift",
    category: "Scissor Lift",
    equipmentType: "Rough Terrain Scissor Lift",
    description: "Rent a 43 ft rough terrain scissor lift for high outdoor platform access and heavy-duty commercial jobsite work. This lift is a strong choice for exterior painting, glazing, steel, construction, and building maintenance where crews need height, deck space, and capacity.",
    seoDescription: "Rent a 43 ft rough terrain scissor lift for high outdoor platform access and heavy-duty commercial jobsite work. This lift is a strong choice for exterior painting, glazing, steel, construction, and building maintenance where crews need height, deck space, and capacity.",
    image: "/equipment/eq_11.jpg",
    pricing: {
      daily: 582.0, weekly: 1142.0, monthly: 2206.0,
      competitor: { daily: 765.00, weekly: 1475.00, monthly: 2605.00 },
    },
    features: ["43' working height", "Extreme terrain", "Heavy-duty"],
    brands: [
      {
        name: "Genie", model: "GS-4390 RT", image: "/equipment/eq_11.jpg",
        pricing: { daily: 582.0, weekly: 1142.0, monthly: 2206.0 },
        specs: {
          "Equipment Type": 'Rough terrain scissor',
          "Work Height": '49 ft',
          "Platform Height": '43 ft',
          "Machine Length": '12 ft 11.25 in',
          "Machine Width": '7 ft 8 in',
          "Stowed Height": '9 ft 7 in',
          "Platform Capacity": '1,500 lbs',
          "Operating Weight": '12,894 lbs',
          "Power": 'Gas / LPG',
        },
      },
    ],
  },
  {
    id: 11,
    name: "15' Vertical Mast Lift",
    category: "Scissor Lift",
    equipmentType: "Vertical Mast Lift",
    description: "Rent a 15 ft vertical mast lift for quiet, compact indoor work in narrow areas. This lift is ideal for electrical, HVAC, fire alarm, lighting, warehouse, and facility maintenance jobs where maneuverability matters.",
    seoDescription: "Rent a 15 ft vertical mast lift for quiet, compact indoor work in narrow areas. This lift is ideal for electrical, HVAC, fire alarm, lighting, warehouse, and facility maintenance jobs where maneuverability matters.",
    image: "/equipment/eq_14.jpg",
    pricing: {
      daily: 316.8, weekly: 552.0, monthly: 809.6,
      competitor: { daily: 370.00, weekly: 540.00, monthly: 805.00 },
    },
    features: ["15' working height", "Narrow footprint", "Electric"],
    brands: [
      {
        name: "Skyjack", model: "SJ16 E", image: "/equipment/eq_14.jpg",
        pricing: { daily: 316.8, weekly: 552.0, monthly: 809.6 },
        specs: {
          "Equipment Type": 'Vertical mast lift',
          "Work Height": '21 ft 6 in',
          "Platform Height": '15 ft 6 in',
          "Machine Length": '54"',
          "Machine Width": '30.5"',
          "Stowed Height": '74"',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '2,054 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "GR-15", image: "/equipment/eq_15.jpg",
        pricing: { daily: 316.8, weekly: 552.0, monthly: 809.6 },
        specs: {
          "Equipment Type": 'Vertical mast lift',
          "Work Height": '20 ft 8 in',
          "Platform Height": '14 ft 8 in',
          "Machine Length": '4 ft 5 in',
          "Machine Width": '2 ft 5.5 in',
          "Stowed Height": '5 ft 10 in',
          "Platform Capacity": '500 lbs',
          "Operating Weight": '2,178 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 12,
    name: "20' Vertical Mast Lift",
    category: "Scissor Lift",
    equipmentType: "Vertical Mast Lift",
    description: "Rent a 20 ft vertical mast lift when you need higher indoor reach in a compact footprint. This lift is commonly used for lighting, sprinkler, HVAC, warehouse, and facility maintenance work in tight spaces.",
    seoDescription: "Rent a 20 ft vertical mast lift when you need higher indoor reach in a compact footprint. This lift is commonly used for lighting, sprinkler, HVAC, warehouse, and facility maintenance work in tight spaces.",
    image: "/equipment/eq_16.jpg",
    pricing: {
      daily: 333.6, weekly: 608.0, monthly: 888.0,
      competitor: { daily: 410.00, weekly: 605.00, monthly: 900.00 },
    },
    features: ["20' working height", "Compact design", "Zero emissions"],
    brands: [
      {
        name: "Skyjack", model: "SJ20 E", image: "/equipment/eq_16.jpg",
        pricing: { daily: 333.6, weekly: 608.0, monthly: 888.0 },
        specs: {
          "Equipment Type": 'Vertical mast lift',
          "Work Height": '25 ft 6 in',
          "Platform Height": '19 ft 6 in',
          "Machine Length": '54"',
          "Machine Width": '31.5"',
          "Stowed Height": '79.5"',
          "Platform Capacity": '350 lbs',
          "Operating Weight": '2,440 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "GR-20", image: "/equipment/eq_17.jpg",
        pricing: { daily: 333.6, weekly: 608.0, monthly: 888.0 },
        specs: {
          "Equipment Type": 'Vertical mast lift',
          "Work Height": '25 ft 9 in',
          "Platform Height": '19 ft 9 in',
          "Machine Length": '4 ft 5 in',
          "Machine Width": '2 ft 7.5 in',
          "Stowed Height": '6 ft 6 in',
          "Platform Capacity": '350 lbs',
          "Operating Weight": '2,513 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "GS-4390 RT", image: "/equipment/eq_18.jpg",
        pricing: { daily: 333.6, weekly: 608.0, monthly: 888.0 },
        specs: {
          "Equipment Type": 'Rough terrain scissor',
          "Work Height": '49 ft',
          "Platform Height": '43 ft',
          "Machine Length": '12 ft 11.25 in',
          "Machine Width": '7 ft 8 in',
          "Stowed Height": '9 ft 7 in',
          "Platform Capacity": '1,500 lbs',
          "Operating Weight": '12,894 lbs',
          "Power": 'Gas / LPG',
        },
      },
    ],
  },

  // ============ BOOM LIFT ============
  {
    id: 13,
    name: "30'-34' Articulating Electric Boom Lift",
    displayName: "30' Electric Boom Lift",
    category: "Boom Lift",
    equipmentType: "Articulating Boom Lift",
    description: "A compact electric articulating boom lift with up-and-over reach for accessing elevated areas around obstacles.",
    seoDescription: "Rent a 30 to 34 ft electric articulating boom lift for quiet indoor or slab work that requires up-and-over reach. These electric boom lifts are useful for reaching around obstacles on electrical, HVAC, signage, painting, and facility maintenance jobs.",
    image: "/equipment/eq_19.jpg",
    featured: true,
    featuredOrder: 4,
    pricing: {
      daily: 503.6, weekly: 1018.8, monthly: 1814.0,
      competitor: { daily: 650.00, weekly: 1255.00, monthly: 2215.00 },
    },
    features: [
      "Articulating boom reaches up, over, and around obstacles",
      "Electric operation works well indoors or on sensitive job sites",
      "Great for areas where a scissor lift cannot position directly underneath",
    ],
    brands: [
      {
        name: "JLG", model: "E300AJP", image: "/equipment/eq_19.jpg",
        pricing: { daily: 503.6, weekly: 1018.8, monthly: 1814.0 },
        specs: {
          "Equipment Type": 'Electric articulating boom',
          "Working Height": '35 ft 5 in',
          "Platform Height": '29 ft 5 in',
          "Horizontal Outreach": '20 ft 1 in',
          "Up & Over Height": '13 ft 2 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '18 ft 10 in',
          "Machine Width": '4 ft',
          "Stowed Height": '6 ft 7 in',
          "Operating Weight": '15,650 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "Z-30/20N", image: "/equipment/eq_20.jpg",
        pricing: { daily: 503.6, weekly: 1018.8, monthly: 1814.0 },
        specs: {
          "Equipment Type": 'Electric articulating boom',
          "Working Height": '36 ft',
          "Platform Height": '30 ft',
          "Horizontal Outreach": '21 ft 5 in',
          "Up & Over Height": '12 ft 8 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '16 ft 5 in',
          "Machine Width": '3 ft',
          "Stowed Height": '6 ft 6 in',
          "Operating Weight": '14,587 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "Z-34/22N", image: "/equipment/eq_21.jpg",
        pricing: { daily: 503.6, weekly: 1018.8, monthly: 1814.0 },
        specs: {
          "Equipment Type": 'Electric articulating boom',
          "Working Height": '40 ft 6 in',
          "Platform Height": '34 ft 6 in',
          "Horizontal Outreach": '22 ft 3 in',
          "Up & Over Height": '15 ft 3 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '18 ft 9 in',
          "Machine Width": '4 ft 10 in',
          "Stowed Height": '6 ft 7 in',
          "Operating Weight": '11,400 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 14,
    name: "40'-45' Articulating Electric Boom Lift",
    category: "Boom Lift",
    equipmentType: "Articulating Boom Lift",
    description: "Rent a 40 to 45 ft electric articulating boom lift for clean, quiet jobsites where crews need to reach over walls, equipment, or other obstacles. This lift works well in warehouses, schools, malls, industrial facilities, and indoor commercial construction.",
    seoDescription: "Rent a 40 to 45 ft electric articulating boom lift for clean, quiet jobsites where crews need to reach over walls, equipment, or other obstacles. This lift works well in warehouses, schools, malls, industrial facilities, and indoor commercial construction.",
    image: "/equipment/eq_22.jpg",
    pricing: {
      daily: 570.8, weekly: 1198.0, monthly: 2206.0,
      competitor: { daily: 755.00, weekly: 1455.00, monthly: 2570.00 },
    },
    features: ["40-45' reach", "Zero emissions", "Up and over capability"],
    brands: [
      {
        name: "JLG", model: "E400AJPN", image: "/equipment/eq_22.jpg",
        pricing: { daily: 570.8, weekly: 1198.0, monthly: 2206.0 },
        specs: {
          "Equipment Type": 'Electric articulating boom',
          "Working Height": '46 ft',
          "Platform Height": '40 ft',
          "Horizontal Outreach": '22 ft 5 in',
          "Up & Over Height": '21 ft 6 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '22 ft',
          "Machine Width": '4 ft',
          "Stowed Height": '6 ft 7 in',
          "Operating Weight": '14,900 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Genie", model: "Z-40/23N", image: "/equipment/eq_23.jpg",
        pricing: { daily: 570.8, weekly: 1198.0, monthly: 2206.0 },
        specs: {
          "Equipment Type": 'Electric articulating boom',
          "Working Height": '46 ft 5 in',
          "Platform Height": '40 ft 5 in',
          "Horizontal Outreach": '22 ft 8 in',
          "Up & Over Height": '21 ft 3 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '21 ft 5 in',
          "Machine Width": '4 ft 11 in',
          "Stowed Height": '6 ft 7 in',
          "Operating Weight": '15,350 lbs',
          "Power": 'Battery electric',
        },
      },
      {
        name: "Snorkel", model: "A46JE", image: "/equipment/eq_24.jpg",
        pricing: { daily: 570.8, weekly: 1198.0, monthly: 2206.0 },
        specs: {
          "Equipment Type": 'Electric articulating boom',
          "Working Height": '52 ft 3 in',
          "Platform Height": '46 ft 3 in',
          "Horizontal Outreach": '24 ft 11 in',
          "Up & Over Height": '24 ft 6 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '18 ft 4 in',
          "Machine Width": '5 ft 8 in',
          "Stowed Height": '6 ft 7 in',
          "Operating Weight": '14,690 lbs',
          "Power": 'Battery electric',
        },
      },
    ],
  },
  {
    id: 15,
    name: "40'-45' IC Telescopic Boom Lift",
    category: "Boom Lift",
    equipmentType: "Telescopic Boom Lift",
    description: "Rent a 40 to 45 ft telescopic boom lift for outdoor work that requires straight horizontal reach. These boom lifts are commonly used for exterior painting, steel, roofing, signage, and building maintenance.",
    seoDescription: "Rent a 40 to 45 ft telescopic boom lift for outdoor work that requires straight horizontal reach. These boom lifts are commonly used for exterior painting, steel, roofing, signage, and building maintenance.",
    image: "/equipment/eq_25.jpg",
    pricing: {
      daily: 733.2, weekly: 1604.56, monthly: 3438.0,
      competitor: { daily: 690.00, weekly: 1330.00, monthly: 2350.00 },
    },
    features: ["40-45' reach", "Diesel/gas power", "Straight reach"],
    brands: [
      {
        name: "Genie", model: "S-40", image: "/equipment/eq_25.jpg",
        pricing: { daily: 733.2, weekly: 1604.56, monthly: 3438.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom',
          "Working Height": '46 ft',
          "Platform Height": '40 ft',
          "Horizontal Outreach": '31 ft 8 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '24 ft 3 in',
          "Machine Width": '7 ft 6 in',
          "Stowed Height": '8 ft 2 in',
          "Operating Weight": '12,310 lbs',
          "Power": 'Diesel / dual fuel varies',
        },
      },
      {
        name: "Genie", model: "S-45 w/JIB", image: "/equipment/eq_26.jpg",
        pricing: { daily: 733.2, weekly: 1604.56, monthly: 3438.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom with jib',
          "Working Height": '51 ft',
          "Platform Height": '45 ft',
          "Horizontal Outreach": '36 ft 8 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '27 ft 10 in',
          "Machine Width": '7 ft 6 in',
          "Stowed Height": '8 ft 2 in',
          "Operating Weight": '15,230 lbs',
          "Power": 'Diesel / dual fuel varies',
        },
      },
      {
        name: "Skyjack", model: "SJ45T w/JIB", image: "/equipment/eq_27.jpg",
        pricing: { daily: 733.2, weekly: 1604.56, monthly: 3438.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom with jib',
          "Work Height": '51 ft 2 in',
          "Platform Height": '45 ft 2 in',
          "Horizontal Outreach": '39 ft 9 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '28 ft 10 in',
          "Machine Width": '7 ft 6 in',
          "Stowed Height": '7 ft 10 in',
          "Operating Weight": '14,830 lbs',
          "Power": 'Diesel',
        },
      },
    ],
  },
  {
    id: 16,
    name: "60'-65' IC Telescopic Boom Lift",
    displayName: "60' IC Straight Boom Lift",
    category: "Boom Lift",
    equipmentType: "Telescopic Boom Lift",
    description: "A diesel-powered telescopic boom lift built for high-reach outdoor access with strong horizontal outreach.",
    seoDescription: "Rent a 60 to 65 ft boom lift for long outdoor reach on commercial construction and industrial jobsites. This height range is commonly used for exterior painting, steel, glazing, roofline access, warehouse exteriors, and maintenance work.",
    image: "/equipment/eq_28.jpg",
    featured: true,
    featuredOrder: 6,
    pricing: {
      daily: 1108.4, weekly: 2206.0, monthly: 5566.0,
      competitor: { daily: 885.00, weekly: 1710.00, monthly: 3020.00 },
    },
    features: [
      "Straight boom design provides strong forward and horizontal reach",
      "Built for high outdoor work on larger buildings and open jobsites",
      "Commonly used for steel work, exterior painting, signs, roofing, and construction access",
    ],
    brands: [
      {
        name: "JLG", model: "600A", image: "/equipment/eq_28.jpg",
        pricing: { daily: 1108.4, weekly: 2206.0, monthly: 5566.0 },
        specs: {
          "Equipment Type": 'IC straight boom',
          "Working Height": '66 ft 5 in',
          "Platform Height": '60 ft 5 in',
          "Horizontal Outreach": '39 ft 7 in',
          "Up & Over Height": '26 ft 7 in',
          "Platform Capacity": '500 lbs unrestricted / 1,000 lbs restricted',
          "Stowed Length": '28 ft 11.5 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '8 ft 4 in',
          "Operating Weight": '22,150 lbs',
          "Power": 'Diesel',
        },
      },
      {
        name: "Genie", model: "S-60", image: "/equipment/eq_29.jpg",
        pricing: { daily: 1108.4, weekly: 2206.0, monthly: 5566.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom',
          "Working Height": '66 ft',
          "Platform Height": '60 ft',
          "Horizontal Outreach": '50 ft 10 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '27 ft 9 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '8 ft 11 in',
          "Operating Weight": '22,256 lbs',
          "Power": 'Diesel / dual fuel varies',
        },
      },
      {
        name: "Skyjack", model: "SJ61T", image: "/equipment/eq_30.jpg",
        pricing: { daily: 1108.4, weekly: 2206.0, monthly: 5566.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom',
          "Work Height": '67 ft 3 in',
          "Platform Height": '61 ft 3 in',
          "Horizontal Outreach": '51 ft 3 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '30 ft 3.75 in',
          "Machine Width": '8 ft',
          "Stowed Height": '8 ft 6 in',
          "Operating Weight": '25,600 lbs',
          "Power": 'Diesel',
        },
      },
      {
        name: "JLG", model: "600AJ w/JIB", image: "/equipment/eq_31.jpg",
        pricing: { daily: 1108.4, weekly: 2206.0, monthly: 5566.0 },
        specs: {
          "Equipment Type": 'IC articulating boom with jib',
          "Working Height": '66 ft 7 in',
          "Platform Height": '60 ft 7 in',
          "Horizontal Outreach": '39 ft 9 in',
          "Up & Over Height": '26 ft 7 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '28 ft 11.5 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '8 ft 4 in',
          "Operating Weight": '22,691 lbs',
          "Power": 'Diesel',
        },
      },
      {
        name: "Skyjack", model: "SJ66T w/JIB", image: "/equipment/eq_32.jpg",
        pricing: { daily: 1108.4, weekly: 2206.0, monthly: 5566.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom with jib',
          "Work Height": '72 ft',
          "Platform Height": '66 ft',
          "Horizontal Outreach": '57 ft',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '34 ft 1.5 in',
          "Machine Width": '8 ft',
          "Stowed Height": '8 ft 6 in',
          "Operating Weight": '26,699 lbs',
          "Power": 'Diesel',
        },
      },
      {
        name: "Genie", model: "S-65 w/JIB", image: "/equipment/eq_33.jpg",
        pricing: { daily: 1108.4, weekly: 2206.0, monthly: 5566.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom with jib',
          "Work Height": '71 ft',
          "Platform Height": '65 ft',
          "Horizontal Outreach": '56 ft 2 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '30 ft 11 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '8 ft 11 in',
          "Operating Weight": '22,800 lbs',
          "Power": 'Diesel / dual fuel varies',
        },
      },
    ],
  },
  {
    id: 17,
    name: "80'-86' IC Telescopic Boom Lift",
    category: "Boom Lift",
    equipmentType: "Telescopic Boom Lift",
    description: "Rent an 80 to 86 ft telescopic boom lift for high-reach outdoor work where crews need height and horizontal reach. These lifts are ideal for large tilt-up buildings, exterior painting, stadiums, industrial sites, glazing, and hard-to-reach elevations.",
    seoDescription: "Rent an 80 to 86 ft telescopic boom lift for high-reach outdoor work where crews need height and horizontal reach. These lifts are ideal for large tilt-up buildings, exterior painting, stadiums, industrial sites, glazing, and hard-to-reach elevations.",
    image: "/equipment/eq_34.jpg",
    pricing: {
      daily: 441.25, weekly: 835.0, monthly: 1285.0,
      competitor: { daily: 1145.00, weekly: 2215.00, monthly: 3920.00 },
    },
    features: ["80-86' reach", "Heavy-duty", "Maximum height"],
    brands: [
      {
        name: "Genie", model: "S-80", image: "/equipment/eq_34.jpg",
        pricing: { daily: 441.25, weekly: 835.0, monthly: 1285.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom',
          "Work Height": '86 ft',
          "Platform Height": '80 ft',
          "Horizontal Outreach": '71 ft 6 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '37 ft 7 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '9 ft 2 in',
          "Operating Weight": '35,400 lbs',
          "Power": 'Diesel',
        },
      },
      {
        name: "Genie", model: "S-85 w/JIB", image: "/equipment/eq_35.jpg",
        pricing: { daily: 441.25, weekly: 835.0, monthly: 1285.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom with jib',
          "Work Height": '91 ft',
          "Platform Height": '85 ft',
          "Horizontal Outreach": '76 ft 6 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '40 ft 7 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '9 ft 2 in',
          "Operating Weight": '37,000 lbs',
          "Power": 'Diesel',
        },
      },
      {
        name: "Skyjack", model: "SJ86T w/JIB", image: "/equipment/eq_36.jpg",
        pricing: { daily: 441.25, weekly: 835.0, monthly: 1285.0 },
        specs: {
          "Equipment Type": 'IC telescopic boom with jib',
          "Work Height": '92 ft',
          "Platform Height": '86 ft',
          "Horizontal Outreach": '76 ft 10 in',
          "Platform Capacity": '500 / 750 lbs dual capacity',
          "Stowed Length": '42 ft 6 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '9 ft 10 in',
          "Operating Weight": '38,000 lbs',
          "Power": 'Diesel',
        },
      },
    ],
  },
  {
    id: 18,
    name: "40'-45' IC Articulating Boom Lift",
    displayName: "40' IC Boom Lift",
    category: "Boom Lift",
    equipmentType: "Articulating Boom Lift",
    description: "A diesel or gas-powered rough-terrain boom lift designed for outdoor elevated access on construction jobsites.",
    seoDescription: "Rent a 40 to 45 ft articulating boom lift for outdoor jobs where crews need to reach up, over, and around obstacles. This lift is great for painting, mechanical, electrical, glazing, signage, and building maintenance.",
    image: "/equipment/eq_37.jpg",
    featured: true,
    featuredOrder: 5,
    pricing: {
      daily: 570.8, weekly: 1198.0, monthly: 2206.0,
      competitor: { daily: 780.00, weekly: 1510.00, monthly: 2665.00 },
    },
    features: [
      "Built for outdoor jobsites and rougher ground conditions",
      "Provides flexible access for exterior walls, framing, and repairs",
      "Good all-around boom lift size for construction and painting work",
    ],
    brands: [
      {
        name: "Genie", model: "Z45/25J", image: "/equipment/eq_37.jpg",
        pricing: { daily: 570.8, weekly: 1198.0, monthly: 2206.0 },
        specs: {
          "Equipment Type": 'IC articulating boom with jib',
          "Working Height": '51 ft 6 in',
          "Platform Height": '45 ft 6 in',
          "Horizontal Outreach": '24 ft 8 in',
          "Up & Over Height": '23 ft 7 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '21 ft 10 in',
          "Machine Width": '7 ft 6 in',
          "Stowed Height": '7 ft 7 in',
          "Operating Weight": '14,800 lbs',
          "Power": 'Diesel / dual fuel varies',
        },
      },
      {
        name: "JLG", model: "450AJ", image: "/equipment/eq_38.jpg",
        pricing: { daily: 570.8, weekly: 1198.0, monthly: 2206.0 },
        specs: {
          "Equipment Type": 'IC articulating boom with jib',
          "Working Height": '51 ft',
          "Platform Height": '45 ft',
          "Horizontal Outreach": '25 ft',
          "Up & Over Height": '24 ft',
          "Platform Capacity": '550 lbs unrestricted',
          "Stowed Length": '21 ft 7 in',
          "Machine Width": '7 ft 9 in',
          "Stowed Height": '7 ft 5 in',
          "Operating Weight": '14,150 lbs',
          "Power": 'Diesel',
        },
      },
    ],
  },
  {
    id: 19,
    name: "60'-65' IC Articulating Boom Lift",
    category: "Boom Lift",
    equipmentType: "Articulating Boom Lift",
    description: "Rent a 60 to 65 ft articulating boom lift for outdoor jobsites with rooflines, canopies, building corners, or equipment in the way. This lift gives crews up-and-over access for painting, mechanical, steel, glazing, and industrial maintenance.",
    seoDescription: "Rent a 60 to 65 ft articulating boom lift for outdoor jobsites with rooflines, canopies, building corners, or equipment in the way. This lift gives crews up-and-over access for painting, mechanical, steel, glazing, and industrial maintenance.",
    image: "/equipment/eq_39.jpg",
    pricing: {
      daily: 1108.4, weekly: 2206.0, monthly: 5566.0,
      competitor: { daily: 975.00, weekly: 1885.00, monthly: 3335.00 },
    },
    features: ["60-65' reach", "Articulated access", "Rugged terrain"],
    brands: [
      {
        name: "Genie", model: "Z62/40", image: "/equipment/eq_39.jpg",
        pricing: { daily: 1108.4, weekly: 2206.0, monthly: 5566.0 },
        specs: {
          "Equipment Type": 'IC articulating boom',
          "Working Height": '67 ft 11 in',
          "Platform Height": '61 ft 11 in',
          "Horizontal Outreach": '40 ft 9 in',
          "Up & Over Height": '25 ft 7 in',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '30 ft 3 in',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '8 ft 4 in',
          "Operating Weight": '21,900 lbs',
          "Power": 'Diesel / dual fuel varies',
        },
      },
    ],
  },
  {
    id: 20,
    name: "80' IC Articulating Boom Lift",
    category: "Boom Lift",
    equipmentType: "Articulating Boom Lift",
    description: "Rent an 80 ft articulating boom lift for high outdoor access where crews need both height and up-and-over reach. This lift is built for large commercial buildings, industrial sites, exterior painting, steel, glazing, and difficult building elevations.",
    seoDescription: "Rent an 80 ft articulating boom lift for high outdoor access where crews need both height and up-and-over reach. This lift is built for large commercial buildings, industrial sites, exterior painting, steel, glazing, and difficult building elevations.",
    image: "/equipment/eq_40.jpg",
    pricing: {
      daily: 441.25, weekly: 835.0, monthly: 1285.0,
      competitor: { daily: 1300.00, weekly: 2520.00, monthly: 4460.00 },
    },
    features: ["80' reach", "Maximum flexibility", "Heavy-duty"],
    brands: [
      {
        name: "Genie", model: "Z80/60", image: "/equipment/eq_40.jpg",
        pricing: { daily: 441.25, weekly: 835.0, monthly: 1285.0 },
        specs: {
          "Equipment Type": 'IC articulating boom',
          "Working Height": '84 ft',
          "Platform Height": '78 ft',
          "Horizontal Outreach": '60 ft',
          "Up & Over Height": '29 ft',
          "Platform Capacity": '500 lbs',
          "Stowed Length": '37 ft',
          "Machine Width": '8 ft 2 in',
          "Stowed Height": '9 ft 10 in',
          "Operating Weight": '37,500 lbs',
          "Power": 'Diesel',
        },
      },
    ],
  },

  // ============ FORK LIFT ============
  {
    id: 21,
    name: "5,000lb Pneumatic Tire Forklift",
    category: "Fork Lift",
    equipmentType: "Pneumatic Fork Lift",
    description: "Rent a 5,000 lb pneumatic tire forklift for loading, unloading, and moving materials around yards, warehouses, and jobsites. Pneumatic tires make this forklift useful for outdoor surfaces while still handling pallets, equipment, and construction materials.",
    seoDescription: "Rent a 5,000 lb pneumatic tire forklift for loading, unloading, and moving materials around yards, warehouses, and jobsites. Pneumatic tires make this forklift useful for outdoor surfaces while still handling pallets, equipment, and construction materials.",
    image: "/equipment/eq_41.jpg",
    pricing: {
      daily: 583.75, weekly: 1146.25, monthly: 2215.0,
      competitor: { daily: 425.00, weekly: 825.00, monthly: 1455.00 },
    },
    features: ["5,000 lbs capacity", "Pneumatic tires", "Indoor/outdoor"],
    brands: [
      {
        name: "Hyster", model: "H50A", image: "/equipment/eq_41.jpg",
        pricing: { daily: 583.75, weekly: 1146.25, monthly: 2215.0 },
        specs: {
          "Equipment Type": 'Pneumatic tire forklift',
          "Lift Capacity": '5,000 lbs',
          "Load Center": '24 in',
          "Max Lift Height": '190 in (typical rental mast)',
          "Capacity at Max Height": 'Varies by mast',
          "Machine Length": 'Approx. 100.7 in to fork face',
          "Machine Width": 'Approx. 47.4 in',
          "Stowed Height / Overhead Guard": 'Approx. 85 in',
          "Operating Weight": 'Approx. 8,500 lbs',
          "Power": 'LPG, pneumatic tires',
        },
      },
    ],
  },

  // ============ TELEHANDLER ============
  {
    id: 22,
    name: "40'-55' Reach 10,000lbs Telehandler",
    category: "Telehandler",
    description: "Rent a 10,000 lb telehandler for heavy material handling on commercial construction sites. This machine is built for lifting pallets, lumber, steel, roofing materials, and equipment to elevated work areas where standard forklifts cannot reach.",
    seoDescription: "Rent a 10,000 lb telehandler for heavy material handling on commercial construction sites. This machine is built for lifting pallets, lumber, steel, roofing materials, and equipment to elevated work areas where standard forklifts cannot reach.",
    image: "/equipment/eq_43.jpg",
    pricing: {
      daily: 441.25, weekly: 835.0, monthly: 1285.0,
      competitor: { daily: 820.00, weekly: 1585.00, monthly: 2800.00 },
    },
    features: ["40-55' reach", "10,000 lbs capacity", "Versatile attachments"],
    brands: [
      {
        name: "JLG / SkyTrak", model: "10042", image: "/equipment/eq_43.jpg",
        pricing: { daily: 441.25, weekly: 835.0, monthly: 1285.0 },
        specs: {
          "Equipment Type": 'Telehandler',
          "Lift Capacity": '10,000 lbs',
          "Max Lift Height": '42 ft 1 in',
          "Max Forward Reach": '26 ft 7 in',
          "Capacity at Max Height": '6,000 lbs',
          "Capacity at Max Reach": '6,000 lbs (stabilized) / 2,000 lbs (outriggers up)',
          "Machine Length": '20 ft 8 in',
          "Machine Width": '8 ft 6 in',
          "Stowed Height": '8 ft 4 in',
          "Operating Weight": '27,300 lbs',
          "Power": 'Diesel',
        },
      },
    ],
  },
];

// Industry Types for Quote Form
export const industryTypes = [
  "Construction",
  "Electrical",
  "HVAC",
  "Plumbing",
  "Painting",
  "Roofing",
  "Property Management",
  "Event Production",
  "Warehousing",
  "Manufacturing",
  "Other",
];

// Years in Business Options
export const yearsInBusinessOptions = [
  "Less than 1 year",
  "1-3 years",
  "3-5 years",
  "5-10 years",
  "10+ years",
];

// Why Choose Us
export const whyChooseUs = [
  { icon: "Truck", title: "Ready When You Need It", description: "We coordinate your lift delivery around the job schedule so your crew can get started without delay." },
  { icon: "Clock", title: "Same-Day Service", description: "Need a lift today? Order today and we'll work quickly to get the right equipment to your jobsite." },
  { icon: "DollarSign", title: "Clear Out-the-Door Pricing", description: "Know exactly what you're paying before you order — clear rates, simple terms, and no hidden fees." },
  { icon: "Award", title: "Customer-First Service", description: "We make it easy to order, schedule, and manage your rental with clear communication from start to finish." },
  { icon: "Wrench", title: "Well-Maintained Fleet", description: "Every lift is inspected and serviced before delivery, so it arrives ready for your jobsite." },
  { icon: "FileText", title: "Easy Ordering", description: "Call or request a quote online — we make it simple to get the right lift for your job." },
];

// Testimonials
export const testimonials = [
  {
    id: 1,
    name: "Creative Indulgence",
    company: "",
    text: "Best rental lift company in the area, fast and very responsive of our needs when working on sign installs or events. Lifts are always charged up and pick and delivery is flexable.",
    rating: 5,
  },
  {
    id: 2,
    name: "Lawrence Russell",
    company: "The Law Russell Los Angeles",
    text: "Great Customer Service and quick with the bottom line. They beat everyone else's starting price. Get the most qualified piece of equipment they have available. I got to use the 45' diesel articulating boom for 11 days, next time I'm going to borrow the 60'. Their service tech was quick to respond on site when the lift had any issue. They were very generous and human when I needed extra time with the machine. I'm calling again soon asking for Dan.",
    rating: 5,
  },
  {
    id: 3,
    name: "Christopher Livaccari",
    company: "",
    text: "Cooper Equipment Rentals has always been first class service for my business. Use them!!",
    rating: 5,
  },
];

// FAQ Data
export const faqCategories = [
  {
    category: "Pricing & Billing",
    questions: [
      { q: "What's included in your pricing?", a: "All our rental rates include delivery, pickup, and our industry-low damage waiver. There are no hidden fees - the price you see is the price you pay." },
      { q: "How does your damage waiver work?", a: "Our damage waiver is included in every rental at no extra cost. It covers normal wear and tear and minor damage, giving you peace of mind on the job site." },
      { q: "Do you offer weekly or monthly rates?", a: "Yes! We offer competitive daily, weekly, and monthly rates. The longer you rent, the more you save. Contact us for custom quotes on extended rentals." },
    ],
  },
  {
    category: "Delivery & Availability",
    questions: [
      { q: "Do you offer same-day delivery?", a: "Yes! If you call before noon, we can usually deliver the same day within our service area (Orange County, Inland Empire, and Los Angeles County)." },
      { q: "What areas do you serve?", a: "We proudly serve Orange County, Inland Empire, and Los Angeles County. Contact us to confirm delivery to your specific location." },
      { q: "How do I check equipment availability?", a: "Call us at 714-379-5545 or request a quote online. Our team will confirm availability and schedule delivery at your convenience." },
    ],
  },
  {
    category: "Equipment & Safety",
    questions: [
      { q: "How often is your equipment inspected?", a: "Every piece of equipment goes through our rigorous 8-step quality inspection process before each rental. Safety and reliability are our top priorities." },
      { q: "What if equipment breaks down on the job?", a: "We offer 24/7 support. If equipment fails due to a mechanical issue, we'll replace it immediately at no charge to you." },
      { q: "Do you provide training or operator manuals?", a: "Yes, we provide operator manuals with every rental. For customers who need it, we can arrange certified training through our partners." },
    ],
  },
];
